import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
  logo:{
    '&.MuiAvatar-root':{
      margin:'0 auto',
      width:'240px',
      height:'auto',
    }
  },
  toolbarRoot:{
    '&.MuiToolbar-root':{
      [theme.breakpoints.down('900')]:{
        display:'none'
      }
    }
  },
  backDropDiv:{
    position:"fixed",
    width:'100%',
    height:'30px',
    top:0,
    right:0,
    zIndex:1050,
    backdropFilter:' blur(4px)',
  },
  mainGrid:{
    '&.MuiGrid-root':{
      marginLeft:10,
      [theme.breakpoints.down('900')]:{
        marginLeft:0
      }
    }
  },
  notVisible: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
  },
}));
